export function validateImageContentWrite(content: unknown): string | null {
  if (content === '' || content === null) {
    return null;
  }
  if (typeof content !== 'string') {
    return null;
  }
  if (content === 'logo' || content === 'brand_logo') {
    return null;
  }
  if (looksLikeUrl(content)) {
    return null;
  }
  return 'Image content must be the full URL template from read contentTemplate, including the https URL and brace tokens.';
}

function looksLikeUrl(value: string): boolean {
  return /^https?:\/\//i.test(value) || value.startsWith('data:') || value.startsWith('blob:');
}
